//OtkritieRegistratsiiNaZasedaniePravleniyaFederatsii
import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { DatePicker, Form, Input } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import locale from 'antd/es/date-picker/locale/ru_RU';

import REDUX_ZasedaniyaRegionalnogoPravleniya from '../../../objects/ZasedaniyaRegionalnogoPravleniya/reducer'
dayjs.locale('ru');

export default function OtkritieRegistratsiiNaZasedaniyaRegionalnogoPravleniya(props) {
    const { object, zasedanie } = props;
    // const zasedanie = useSelector(REDUX_ZasedaniyaRegionalnogoPravleniya.selector.objectByKey(object.ID));
    
    // const [city, setCity] = useState([]);

    // useEffect(() => {
    //     auth.fetch('/api/query/City?s-name').then(res => {
    //         if (res && res.data) {
    //             setCity(res.data);
    //         }
    //     });
    // }, []);

    // const options = city.map(i => (
    //     <Option key={i.ID} value={i.ID}>{i.name}</Option>
    // ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                // neobkhodimiiKvorum: 50,
                zasedanieRegionalnogoPravleniyaID: zasedanie.ID,
                dataNachalaRegistratsiiUchastnikov: dayjs()
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedanieRegionalnogoPravleniyaID"}
                label={"Заседание регионального правления"}
                rules={[{ required: true, message: 'Укажите заседание регионального правления!' }]}
            >
                <Input disabled />
            </Form.Item>

            <Form.Item
                name={"dataNachalaRegistratsiiUchastnikov"}
                label={"Дата начала регистрации участников"}
                rules={[{ required: true, message: 'Укажите дату начала регистрации участников!' }]}
            >
                <DatePicker locale={locale} />
            </Form.Item>
        </Form>
    );
}
